<template>
  <v-container fluid>
    <base-material-card
      color="primary"
      icon="mdi-file-link-outline"
      inline
      class="ml-0 px-5 py-4"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          Log de Unitização
        </div>
      </template>

      <div class="log-unitizacao-historico-acoes">
        <v-btn
          id="btn-nova-consulta-log-unitizacao"
          color="success"
          dark
          elevation="1"
          class="my-5"
          relative
          text
          medium
          @click="$router.push({ name: 'Log de Unitização Pesquisa' })"
        >
          <v-icon
            left
            size="30px"
          >
            mdi-plus-circle
          </v-icon>
          Nova Consulta
        </v-btn>

        <v-btn
          id="btn-novo-upload-log-unitizacao"
          color="success"
          dark
          elevation="1"
          class="my-5"
          relative
          text
          medium
          @click="$router.push({ name: 'Log de Unitização Upload' })"
        >
          <v-icon
            left
            size="30px"
          >
            mdi-file-upload-outline
          </v-icon>
          Nova Unitização
        </v-btn>
      </div>

      <v-tabs
        id="log-unitizacao-tabs-historico"
        v-model="tab"
        background-color="grey lighten-3"
        active-class="primary white--text"
        grow
        height="56"
        hide-slider
        class="log-unitizacao-historico-tabs"
        style="clear: both;"
      >
        <v-tab
          v-for="item in tabs"
          :key="item"
          :ripple="false"
        >
          {{ item }}
        </v-tab>
      </v-tabs>

      <div class="my-6" />

      <v-tabs-items
        v-model="tab"
        class="transparent"
      >
        <v-tab-item>
          <tabela-consultas
            :items="consultas"
            :uploads="lotes"
            :loading="loadingConsultas"
            @rechargeTable="getConsultas"
            @switchProcessamentosExpirados="processamentosExpiradosConsultas = $event; getConsultas()"
          />
        </v-tab-item>

        <v-tab-item>
          <tabela-uploads
            :items="lotes"
            :loading="loadingLotes"
            @rechargeTable="getLotes"
            @switchProcessamentosExpirados="processamentosExpiradosUploads = $event; getLotes()"
          />
        </v-tab-item>
      </v-tabs-items>
    </base-material-card>
  </v-container>
</template>

<script>
import LogUnitizacaoService from '@/services/LogUnitizacaoService';
import pusherMixins from '@/mixins/pusherMixins';

export default {
  name: 'LogUnitizacaoHistorico',

  mixins: [pusherMixins],

  components: {
    TabelaConsultas: () => import('@/components/logUnitizacao/TabelaConsultas.vue'),
    TabelaUploads: () => import('@/components/logUnitizacao/Tabela.vue')
  },

  data() {
    return {
      tab: 0,
      tabs: ['Consultas', 'Unitizações'],
      consultas: [],
      lotes: [],
      loadingConsultas: false,
      loadingLotes: false,
      processamentosExpiradosConsultas: false,
      processamentosExpiradosUploads: false
    };
  },

  mounted() {
    this.tab = this.getTabFromRoute();
    this.getConsultas();
    this.getLotes();
    this.subscribe();
  },

  watch: {
    '$route.query.tab'() {
      this.tab = this.getTabFromRoute();
    }
  },

  methods: {
    subscribe() {
      this.pusherChannel.bind('refreshLogUnitizacao', () => {
        this.getConsultas();
        this.getLotes();
      });
    },

    getTabFromRoute() {
      return this.$route.query.tab === 'uploads' ? 1 : 0;
    },

    getConsultas() {
      this.loadingConsultas = true;

      LogUnitizacaoService.getConsultas(this.processamentosExpiradosConsultas)
        .then((response) => {
          this.consultas = response.data.data || [];
        })
        .catch((error) => {
          this.$toast.error('Erro ao carregar histórico de consultas de Log de Unitização.', '', { position: 'topRight' });
          console.error(error);
        })
        .finally(() => {
          this.loadingConsultas = false;
        });
    },

    getLotes() {
      this.loadingLotes = true;

      LogUnitizacaoService.getLotes(this.processamentosExpiradosUploads)
        .then((response) => {
          this.lotes = response.data.data || [];
        })
        .catch((error) => {
          this.$toast.error('Erro ao carregar histórico de uploads de Log de Unitização.', '', { position: 'topRight' });
          console.error(error);
        })
        .finally(() => {
          this.loadingLotes = false;
        });
    }
  }
};
</script>

<style lang="sass">
.log-unitizacao-historico-acoes
  display: flex
  justify-content: space-between
  align-items: center
  gap: 8px
  flex-wrap: wrap
  margin-bottom: 20px

.log-unitizacao-historico-tabs
  margin-top: 0 !important

.log-unitizacao-historico-tabs .v-slide-group__wrapper
  width: 100%

.log-unitizacao-historico-tabs .v-slide-group__content
  width: 100%

.log-unitizacao-historico-tabs .v-tab
  flex: 1 1 50%
  max-width: none
  min-height: 56px
  font-weight: 500
  color: rgba(0, 0, 0, 0.6) !important

.log-unitizacao-historico-tabs .v-tab--active
  color: #fff !important
</style>
